<p class="mb-2">{{ 'urval.group-urval-on' | translate:{urval: treeViewData.title} }}</p>

<ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" orientation="vertical" [destroyOnHide]="true" (navChange)="beforeChange()">
  @for (treeViewGroupData of treeViewData.treeViewGroupData; track treeViewGroupData; let i = $index) {
    <li [ngbNavItem]="i">
      <a ngbNavLink>{{treeViewGroupData.title}}</a>
      <ng-template ngbNavContent>
        <hr />
        <checkbox-treeview
          [treeviewData]="treeViewGroupData.items"
          [showFilter]="showFilter"
          (selectedChange)="onSelectedChange($event)">
        </checkbox-treeview>
      </ng-template>
    </li>
  }
</ul>

<div [ngbNavOutlet]="nav"></div>

<!-- <ngb-tabset type="pills" [destroyOnHide]="true" (tabChange)="beforeChange()" >
<ngb-tab *ngFor="let treeViewGroupData of treeViewData.treeViewGroupData" [title]="treeViewGroupData.title">
  <ng-template ngbTabContent>
    <hr />

    <checkbox-treeview
      [treeviewData]="treeViewGroupData.items"
      [showFilter]="showFilter"
      (selectedChange)="onSelectedChange($event)">
    </checkbox-treeview>

  </ng-template>
</ngb-tab>
</ngb-tabset> -->